import { type TreeRelation } from '@halo/utils';
import type { RouteItem } from '@/scripts/router/types';
import { genRoutes } from '@/scripts/router/utils-runtime';
import Paths from './paths';
import { routeMapRuntime as map } from './routeMap-runtime';

export const routesRelation: TreeRelation<RouteItem> = [
  map[Paths.LOGIN],
  map[Paths.AUTH_CALLBACK],
  map[Paths.KICK_OUT],
  map[Paths.ERROR],
  [
    map[Paths.MAIN],
    [
      map[Paths.CALLS],
      [map[Paths.MESSAGES], [map[Paths.MESSAGES_CHATS]]],
      [map[Paths.CONTACTS], [map[Paths.CONTACTS_GROUP_CHAT]]],
      [
        map[Paths.SETTINGS],
        [
          map[Paths.SETTINGS_NOTIFICATIONS],
          map[Paths.SETTINGS_GENERAL],
          map[Paths.SETTINGS_SECURITY],
          map[Paths.SETTINGS_PRIVACY],
          map[Paths.SETTINGS_SYNC_BACKUP],
          map[Paths.SETTINGS_DEVICES],
          map[Paths.SETTINGS_ABOUT],
          map[Paths.SETTINGS_LANGUAGE],
        ],
      ],
      map[Paths.SHORTS],
      map[Paths.DOCS],
    ],
  ],
  map[Paths.NOT_FOUND],
];

export const routes = genRoutes([[map[Paths.BASE], routesRelation]]);
